import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiDtgCarService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    getListStatus(companyId:any,dtgEid:string,dtgUnitId:string,dtgTeamId:string,searchValue:string,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/status/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpSearchInfo = {
            "companyId":companyId
            ,"dtgEid":dtgEid
            ,"dtgUnitId":dtgUnitId
            ,"dtgTeamId":dtgTeamId
            ,"searchValue":searchValue
        };
        let tmpPostObject = {
            "searchInfo":tmpSearchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListGeoHash(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/geohash/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = ["wydm4zkz","wydm4zqu"];
        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListTripInfo(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/trip/info/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "dtgUnitId":"01225239761"
        //     ,"searchDateFrom":"2019-04-06 07:00:00"
        //     ,"searchDateTo":"2019-04-06 08:00:00"
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }



    getListDriveHistory(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/drive/history/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "dtgUnitId":"01040998564"
        //     ,"dtgTripCnt":1
        //     ,"searchDateFrom":"2019-04-06 07:00:00"
        //     ,"searchDateTo":"2019-04-06 08:00:00"
        // };
        // pagingInfo = {
        //     "curPage":1
        //     ,"pageSize":100
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListDangerInfoHistory(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/dangerInfo/history/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }
   

    getListCarType(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/type/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListCar(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/manage/car/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        // };
        // pagingInfo = {
        //     "curPage":1
        //     ,"pageSize":100
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListCarExt(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/manage/car/ext/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        // };
        // pagingInfo = {
        //     "curPage":1
        //     ,"pageSize":100
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getCarDetail(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/manage/car/detail";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        // };
        // pagingInfo = {
        //     "curPage":1
        //     ,"pageSize":100
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getCarDetailExt(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/manage/car/ext/detail";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    upsertCar(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/manage/car/upsert";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        // };
        // pagingInfo = {
        //     "curPage":1
        //     ,"pageSize":100
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    upsertCarExt(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/manage/car/ext/upsert";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        // };
        // pagingInfo = {
        //     "curPage":1
        //     ,"pageSize":100
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    findAllCarExtAccept(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/manage/car/ext/accept/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        // };
        // pagingInfo = {
        //     "curPage":1
        //     ,"pageSize":100
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    findAllCompanyExtAcceptNotExists(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/manage/car/ext/accept/company/not/exists";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        // };
        // pagingInfo = {
        //     "curPage":1
        //     ,"pageSize":100
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    upsertDeviceCompanyExtAccept(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/manage/car/ext/accept/company/upsert";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    moveDtgCarCompany(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/car";
        url += "/manage/car/move/company";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }
}